import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import PickUp from '../views/PickUp.vue'
import Finish from '../views/Finish.vue'
import My from '../views/My.vue'
import Detail from '../views/Detail.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/pickup',
    name: 'PickUp',
    component: PickUp
  },
  {
    path: '/finish',
    name: 'Finish',
    component: Finish
  },
  {
    path: '/my',
    name: 'My',
    component: My
  },
  {
    path: '/detail',
    name: 'Detail',
    component: Detail
  },
  // {
  //   path: '/about',
  //   name: 'About',
  //   component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  // }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
